export default "__VITE_ASSET__jmSHdOe2__"